var axios = require("axios");
// import apiConfig from './api-config.js'

var _appId = "";
var _baseUrl = "";

var _loginPage = null;

function setAppId(appId) {
  _appId = appId;
}

function setBaseUrl(url) {
  _baseUrl = url;
}

function setLoginPage(page) {
  _loginPage = page;
}

// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null || o[key] === undefined) {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}

function apiAxios(method, url, params) {
  return new Promise(function(resolve, reject) {
    //过滤空参数
    if (params) {
      params = filterNull(params);
    }

    //传入APPID 参数
    if (!params.appId) {
      params.appId = _appId;
    }

    // console.log("apiAxios", method);
    // console.log("apiAxios params", method === 'POST' || method === 'PUT' ? params : null);
    // console.log("apiAxios url", url);

    let axiosOpt = {
      method: method,
      url: url,
      data: method === "POST" || method === "PUT" ? params : null,
      params: method === "GET" || method === "DELETE" ? params : null,
    };

    //兼容POST JSON 模式
    if (method == "POSTJSON") {
      axiosOpt.method = "POST";
      axiosOpt.data = params;
      axiosOpt.dataType = "json";
    }

    if (method != "POSTJSON") {
      // transformRequest 是为了解决axios发起请求时的参数格式问题。
      axiosOpt.transformRequest = [
        function(data) {
          let ret = "";
          for (let it in data) {
            if (data[it] instanceof Array) {
              // 数组x
              for (let item in data[it]) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it][item]) +
                  "&";
              }
            } else {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
          }
          return ret;
        },
      ];
    }

    axios(axiosOpt)
      .then((res) => {
        //console.log("request success!")
        resolve(res.data);
      })
      .catch((err) => {
        //如果是401，则重定向到登录页
        if (err.response && err.response.status === 401 && _loginPage) {
          // window.location.href = _loginPage;
          if (window != top) {
            top.location.href = _loginPage;
          } else {
            window.location.href = _loginPage;
          }
        } else {
          reject(err);
        }
      });
  });
}

//请求列表
//默认会再API后面增加/query 路径
function _query(api, params) {
  let url = _baseUrl + api + "/query";
  return apiAxios("POST", url, params);
}

//请求某个数据
//默认会再API后面增加/get 路径
function _get(api, params) {
  let url = _baseUrl + api + "/get";
  return apiAxios("POST", url, params);
}

//更新某个数据
//默认会再API后面增加/update 路径
function _updata(api, params) {
  let url = _baseUrl + api + "/updata";
  return apiAxios("POST", url, params);
}

//删除某个数据
//默认会再API后面增加/delete路径
function _delete(api, params) {
  let url = _baseUrl + api + "/delete";
  return apiAxios("POST", url, params);
}

//其他请求,不自动添加API路径
function _do(url, params, method) {
  let m = method ? method : "POST"; //默认使用POST
  //console.log("cc request", m);

  let urlStr = "";
  if (url.indexOf("http://") > -1) {
    urlStr = url;
  } else {
    urlStr = _baseUrl + url;
  }
  //  console.log("cc request urlStr", urlStr);

  return apiAxios(m, urlStr, params);
}

//其他请求,不自动添加API路径
function _doWithoutBaseUrl(url, params, method) {
  let m = method ? method : "POST"; //默认使用POST
  //  console.log("cc request", m);
  return apiAxios(m, url, params);
}

//调用接口
export default {
  setAppId: setAppId,
  setBaseUrl: setBaseUrl,
  setLoginPage: setLoginPage,
  query: _query,
  get: _get,
  updata: _updata,
  delete: _delete,
  do: _do,
};
